document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".parallax-image-with-text").forEach((section) => {
    section
      .querySelectorAll(".parallax-image-with-text__heading--animation")
      .forEach((headingElement) => {
        const words = headingElement.textContent.trim().split(" ");
        headingElement.innerHTML = "";

        words.forEach((word, index) => {
          let span = document.createElement("span");
          span.classList.add("parallax-image-with-text__heading-word");
          span.textContent = word + " ";
          span.style.transitionDelay = `${0.3 * index}s`;
          headingElement.appendChild(span);
        });
      });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("scroll-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    section
      .querySelectorAll(".parallax-image-with-text__heading--animation")
      .forEach((heading) => {
        observer.observe(heading);
      });
  });
});
